import {DestroyRef, Directive, ElementRef, computed, inject, signal} from "@angular/core"

@Directive({
    selector: "[cmHorizontalScrollArrows]",
    exportAs: "cmHorizontalScrollArrows",
    host: {
        "(scroll)": "updateState()",
    },
})
export class HorizontalScrollArrowsDirective {
    private readonly host: HTMLElement = inject(ElementRef).nativeElement
    private readonly destroyRef = inject(DestroyRef)

    private readonly $scrollLeft = signal(0)
    private readonly $scrollWidth = signal(0)
    private readonly $clientWidth = signal(0)

    readonly $canScrollLeft = computed(() => this.$scrollLeft() > 1)
    readonly $canScrollRight = computed(() => this.$scrollLeft() + this.$clientWidth() < this.$scrollWidth() - 1)

    constructor() {
        const resizeObserver = new ResizeObserver(() => this.updateState())
        resizeObserver.observe(this.host)
        const mutationObserver = new MutationObserver(() => this.updateState())
        mutationObserver.observe(this.host, {childList: true, subtree: true, characterData: true})
        this.destroyRef.onDestroy(() => {
            resizeObserver.disconnect()
            mutationObserver.disconnect()
        })
    }

    updateState(): void {
        this.$scrollLeft.set(this.host.scrollLeft)
        this.$scrollWidth.set(this.host.scrollWidth)
        this.$clientWidth.set(this.host.clientWidth)
    }

    scrollByDirection(direction: -1 | 1): void {
        this.host.scrollBy({left: direction * this.host.clientWidth * 0.8, behavior: "smooth"})
    }
}
